import { render, staticRenderFns } from "./Bloco.vue?vue&type=template&id=3f903da8&"
import script from "./Bloco.vue?vue&type=script&lang=js&"
export * from "./Bloco.vue?vue&type=script&lang=js&"
import style0 from "./Bloco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports